import { Link } from 'react-router-dom';

export default function HeroSection() {
  const schemaOrg = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '高潮喷水完全指南',
    url: 'https://cbhfyv.cn/',
    description: '系统讲解高潮喷水生理原理、发生机制、常见误区及健康知识，帮助读者科学了解高潮喷水现象。',
    inLanguage: 'zh-CN',
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrg) }}
      />
      <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Soft%20warm%20flowing%20abstract%20gradient%20background%20with%20organic%20curves%20in%20gentle%20peach%20coral%20and%20sage%20green%20tones%2C%20minimalist%20elegant%20composition%2C%20dreamy%20ethereal%20quality%2C%20no%20text%20no%20people%2C%20medical%20wellness%20aesthetic%2C%20smooth%20flowing%20lines%2C%20warm%20ambient%20lighting%2C%20artistic%20and%20sophisticated&width=1600&height=900&seq=hero-main-2026&orientation=landscape"
            alt="高潮喷水完全指南"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
        </div>

        <div className="relative z-10 w-full px-6 md:px-10 text-center max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight tracking-tight">
            高潮喷水完全指南
          </h1>
          <p className="mt-5 md:mt-6 text-base md:text-lg text-white/80 leading-relaxed max-w-2xl mx-auto">
            系统讲解高潮喷水生理原理、发生机制、常见误区及健康知识，帮助读者科学了解高潮喷水现象，消除困惑，建立正确的身体认知与性健康意识。
          </p>
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/shengli-yuanli"
              className="px-8 py-3.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              开始探索
              <i className="ri-arrow-right-line ml-2 w-4 h-4 inline-flex items-center justify-center"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-full text-sm font-medium hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-12 md:mt-16 flex items-center justify-center gap-8 md:gap-12">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">10+</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">专业科普文章</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">4</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">内容分类</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">100%</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">科学循证</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}